import GiftListTable from "./giftListTable.container";

export default GiftListTable;
